// A game that has been deleted is hidden, not erased: the document is still
// there with its teams, sets and totals, carrying a `deletedAt` marker, and the
// assistant can bring it back.
//
// The lists these predicates guard are read straight from Firestore, not from
// the server, so the server's own filtering never reaches them - an overlay on
// a TV would keep showing a game the events page has already dropped. Firestore
// security rules cannot do this either: a rule cannot filter a query's results,
// it can only accept or fail the whole query.
//
// `deleted` is the older boolean flag, kept because three listeners were
// already checking it. Nothing writes it any more, but a game carrying only
// that flag should still be hidden, so both are tested.
export const isLiveGame = (data) => !data?.deletedAt && data?.deleted !== true;

// The same test for a whole query result, so a listener reduces to reading
// from `liveGameDocs(querySnapshot)` wherever it used `querySnapshot.docs`.
export const liveGameDocs = (snapshot) =>
  (snapshot?.docs || []).filter((docSnap) => isLiveGame(docSnap.data()));
